import { EPlanCheckAction } from "../actions/EPlanCheckAction";
import { SequenceManagerAction } from "../actions/SequenceManagerAction";

const initEPlanCheck = {
    requestBody: {
        sectionId: "E50Check,Installedbase&CustomerDetails",
        steps: [
            {
                sequence: "0",
                offerContainerId: "",
                stepId: "E50Check,Installedbase&CustomerDetails",
                options: [
                    {
                        name: "PackageE50AvailableInInstalledBase",
                        value: ""
                    }
                ],
                fields: [
                    {
                        name: "CustomerRelatedAccountResponse",
                        value: ""
                    }
                ]
            }
        ]
    }
}


const EPlanCheckReducer = (state: any = initEPlanCheck, action: any) => {
    const { type } = action;
    const { payload } = action;
    var ePlanValue = { ...state.requestBody.steps };
    switch (type) {

        case EPlanCheckAction.EPLAN_CHECK_SUCCESS:
            ePlanValue[0].options[0].value = payload.ePlanAvilable;
            ePlanValue[0].fields[0].value = JSON.stringify(payload.customerRelatedAccountResponse);
            ePlanValue[0].offerContainerId = payload.offerContainerId;
            return state;

        case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
            let section = payload.sections.filter((section: any) => {
                return (section.sectionId === 'E50Check,Installedbase&CustomerDetails')
            });
            if (section.length > 0) {
                let ePlanPackage = section[0].steps[0].options[0];
                let ePlanCustomerResponse = section[0].steps[0].fields[0];
                ePlanValue[0].offerContainerId = section[0].steps[0].offerContainerId;
                ePlanValue[0].options[0].value = ePlanPackage ? ePlanPackage.value : "";
                ePlanValue[0].fields[0].value = ePlanCustomerResponse ? ePlanCustomerResponse.value : "";
            }
            return state;

        default:
            return state;
    }
};

export default EPlanCheckReducer;